import React from "react";
import Login from "../../pages/Authentication/Login";

const SignIn = () => {
  return (
    <div>
      <Login />
    </div>
  );
};

export default SignIn;
